<template>
  <div class="wrapBox" style=" padding-left:4px;padding-right:8px;padding-top:8px;">
    <div id="myGoodsIn" :style="{width: '100%', height: '800px'}">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LastYearInOutTrade',
    data() {
      return {
        //msg: 'Welcome to Your Vue.js App',
        titleText: '进口商品贸易类别统计',
        textStyle: {
          color: '#ccc',
          fontStyle: 'normal',
          fontWeight: 'bold',
          fontFamily: 'sans-serif',
          fontSize: 12
        },
        lineNumber: 30,
        legendPadding: [65, 5, 15, 5],
        data1: [],
        data2: []
      }
    },
    computed: {
      myYear() {
        return this.$store.state.myYear
      },
      myCountry() {
        return this.$store.state.myCountry
  
      }
    },
    mounted() {
  
      this.listA();
      //this.drawLine();
    },
    watch: {
      myYear(curval, oldval) {
        this.listA()
      },
      myCountry(curval, oldval) {
        this.listA()
      }
    },
    methods: {
  
      myFormat(params) {
        // console.log('b: ',params);
        var newParamsName = "";
        var paramsNameNumber = params.length;
        var provideNumber = this.lineNumber;
        var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
        if (paramsNameNumber > provideNumber) {
          for (var p = 0; p < rowNumber; p++) {
            var tempStr = "";
            var start = p * provideNumber;
            var end = start + provideNumber;
            if (p == rowNumber - 1) {
              tempStr = params.substring(start, paramsNameNumber);
            } else {
              tempStr = params.substring(start, end) + "\n";
            }
            newParamsName += tempStr;
          }
        } else {
          newParamsName = params;
        }
  
        // console.log('a: ', newParamsName)
        return newParamsName;
  
      },
      listA() {
        var _this = this;
        this.$ajax({
            method: 'get',
            url: '/cee/rest/web/hsAnalysis',
            params: {
              'year': this.myYear,
              'country': this.myCountry,
              'ieflag': '1',
              'limit': '30'
            }
          })
          .then(resp => {
  
            var res1 = [];
            var res2 = [];

            var endDate = resp.data.length && resp.data[0].endDate;
            var myYear = _this.myYear || '';
            var myCountry = _this.myCountry || '';

            _this.titleText = '进口商品贸易类别统计' + (myYear?'-'+myYear:'') + (endDate?'-截至' + endDate:'') + (myCountry?'-'+myCountry:'');

  
            for (let index = 0; index < resp.data.length; index++) {
  
              let element = resp.data[index];
              res1.push(element.name);
              res2.push({
                value: (element.price / 10000.0).toFixed(2),
                content: element
              });
  
            }
  

            this.data1 = res1.reverse();
            this.data2 = res2.reverse();
            this.drawLine();
          })
          .catch(err => {
            //console.log("请求失败：" + err.status + "," + err.statusText);
          });
  
      },
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myGoodsIn = this.$echarts.init(document.getElementById('myGoodsIn'), 'chalk')
        myGoodsIn.setOption({
          title: {
            text: this.titleText,
            left: 'left',
            textStyle: this.textStyle
          },
          tooltip: {
            trigger: 'item',
            enterable: true,  //设置鼠标能否进入提示框浮层
            position: 'inside', //设置浮层位置
            transitionDuration: 0.2,
            axisPointer: {
              type: 'shadow'
            },
            formatter (value) {
              // console.log(value);
              var content = value.data.content;
              // return '<router-link :to="{name:\'GoodsOutD\', query:{name:\''+ content.name +'\', code:\''+ content.code +'\'}}">'+ value.seriesName + ': ' + value.value + '万元\n</router-link>';
              return '<a style="color:#ffffff;" href="../ceeshow/#/GoodsInD?name='+ content.name +'&code='+ content.code +'">'+ value.seriesName + ': ' + value.value + '万元\n</a>';
            }
          },
          legend: {
            data: ['贸易额'],
            x: 'right'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            // boundaryGap: [0, 0.1]
          },
          yAxis: {
  
            type: 'category',
            data: this.data1,
            axisTick: {
              inside: true
            },
            scale: true,
            axisLabel: {
              interval: 0,
              formatter: this.myFormat
            }
  
          },
          series: [{
            name: '贸易额',
            type: 'bar',
            barWidth: 10,
            data: this.data2
          }]
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/GoodsIn.vue